import React from "react";

import styled from "@emotion/styled";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";

import LeftSparkles from "../../assets/images/LeftSparkles.png";
import RightSparkles from "../../assets/images/RightSparkles.png";
import Demo from "../../assets/images/demo.png";

const SummaryDemo = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <LeftDecortation src={LeftSparkles} />
        จบการทดลองเล่น
        <RightDecortation src={RightSparkles} />
      </Header>
      <Description>
        หลังจากบันทึกข้อมูล 4 เป้าหมาย จะถูกคำนวณเป็นคะแนนสะสม
      </Description>
      <Image src={Demo} />
      <BackHome onClick={() => navigate("/")}>กลับไปหน้าแรก</BackHome>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  background-color: #ffa226;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.label`
  position: relative;
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px !important;
  line-height: 28px;

  text-align: center;

  color: #92400e;
  margin-top: 120px;

  ${responsive.tablet(css`
    margin-top: 160px;
  `)}

  ${responsive.mobile(css`
    margin-top: 73px;
  `)}
`;

const LeftDecortation = styled.img`
  position: absolute;
  top: -21px;
  left: -83px;
  width: 63px;
  height: 82px;
`;

const RightDecortation = styled.img`
  position: absolute;
  top: -21px;
  right: -83px;
  width: 63px;
  height: 82px;
`;

const Description = styled.label`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px !important;
  line-height: 26px;

  text-align: center;

  color: #ffffff;

  margin-top: 14px;
  width: 226px;
`;

const Image = styled.img`
  width: 613.22px;
  height: 400px;

  margin: 65px 0;

  ${responsive.mobile(css`
    width: 320px;
    height: 209px;

    margin: 13px 0 46.27px;
  `)}
`;

const BackHome = styled.label`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 20px !important;
  line-height: 26px;

  text-decoration-line: underline;

  color: #fffbeb;
  margin-bottom: 177px;

  :hover {
    cursor: pointer;
  }

  ${responsive.tablet(css`
    margin-bottom: 251px;
    font-size: 18px !important;
  `)}

  ${responsive.mobile(css`
    margin-bottom: 56px;
    font-size: 14px !important;
  `)}
`;

export default SummaryDemo;
